import { FormControl,Select as MuiSelect, InputLabel, MenuItem, FormHelperText } from "@mui/material";
import React from "react";

const Select = (props) => {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options,
  } = props;

  return (
    <FormControl variant="outlined" {...(error && { error: true })}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={value}
        onChange={onChange}
      >
        {options.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.organization_name}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default Select;
